import React from 'react';
import PropTypes from 'prop-types';
import {
  cityLabel,
  codeLabel,
  namesOf,
  useSelectOptions,
} from '../../../helpers/selectOptions';
import ReactiveTable from '../../Organisms/ReactiveTable/ReactiveTable';
import RecordDetails from '../../molecules/RecordDetails/RecordDetails';

// Same list as Museum::REGIONS in the API
const REGIONS = [
  'Central Asia',
  'East Asia',
  'Eurasia',
  'Europe',
  'Middle East',
  'North Africa',
  'North America',
  'Oceania',
  'South America',
  'South Asia',
  'Southeast Asia',
  'Sub-Saharan Africa',
];

const MuseumDetails = ({ data }) => (
  <RecordDetails
    items={[
      { label: 'Architecture', value: data.architecture },
      { label: 'Highlights', value: data.highlights },
      { label: 'Elements', value: namesOf(data.elements) },
      { label: 'Components', value: namesOf(data.components) },
      { label: 'Products', value: namesOf(data.products) },
    ]}
  />
);

MuseumDetails.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
};

const MuseumsPage = () => {
  const cities = useSelectOptions('types/cities?per_page=500', cityLabel);
  const elements = useSelectOptions('instances/building-elements?per_page=500', codeLabel);
  const components = useSelectOptions('instances/building-components?per_page=500', codeLabel);
  const products = useSelectOptions('instances/building-products?per_page=500', codeLabel);
  const columns = [
    {
      name: 'Code',
      selector: row => row.code,
      sortable: true,
      width: '90px',
    },
    {
      name: 'Museum',
      selector: row => row.name,
      sortable: true,
      wrap: true,
    },
    {
      name: 'City',
      selector: row => (row.city ? row.city.name : '-'),
      sortable: true,
    },
    {
      name: 'Country',
      selector: row => (row.city && row.city.country ? row.city.country.name : '-'),
      sortable: true,
    },
    {
      name: 'Region',
      selector: row => row.region,
      sortable: true,
    },
    {
      name: 'Founded',
      selector: row => row.founded,
      sortable: true,
      width: '100px',
    },
  ];
  const fields = [
    'code',
    'name',
    {
      key: 'city_id',
      type: 'select',
      options: cities,
    },
    {
      key: 'region',
      type: 'select',
      options: REGIONS.map(region => ({ label: region, value: region })),
    },
    'founded',
    { key: 'architecture', type: 'textarea' },
    { key: 'highlights', type: 'textarea' },
    {
      key: 'elements_ids',
      type: 'multiselect',
      options: elements,
      valueFrom: museum => museum.elements.map(item => item.id),
    },
    {
      key: 'components_ids',
      type: 'multiselect',
      options: components,
      valueFrom: museum => museum.components.map(item => item.id),
    },
    {
      key: 'products_ids',
      type: 'multiselect',
      options: products,
      valueFrom: museum => museum.products.map(item => item.id),
    },
  ];
  return (
    <>
      <div className="col-md-12 header-container">
        <h2>Museums</h2>
      </div>
      <div className="col-md-12 content-container">
        <ReactiveTable
          columns={columns}
          endpoint="types/museums"
          expandedComponent={MuseumDetails}
          exportableKeys={['code', 'name', 'city_id', 'region', 'founded', 'architecture', 'highlights']}
          modalTitle="Museum"
          fields={fields}
        />
      </div>
    </>
  );
};

export default MuseumsPage;
